
const ServerEnv = {
    sandbox: "sandbox",
    sandbox2: "sandbox2",
    staging: "staging",
    prod: "prod"
}

// localStorage key for environment override
const ENV_OVERRIDE_KEY = "cyokit-env-override";

// Track if we've already logged the environment override this session
let hasLoggedOverride = false;

// Get current server environment
function getCurrentServerEnv() {
    // Check localStorage first for runtime override
    if (typeof localStorage !== "undefined") {
        const override = localStorage.getItem(ENV_OVERRIDE_KEY);
        if (override && Object.values(ServerEnv).includes(override)) {
            if (!hasLoggedOverride) {
                console.warn(`Environment override active: ${override}`);
                hasLoggedOverride = true;
            }
            return override;
        }
    }
    return import.meta.env?.VITE_SERVER_ENV || ServerEnv.sandbox;
}

// Set server environment (saves to localStorage and reloads page)
function setServerEnv(env) {
    if (!Object.values(ServerEnv).includes(env)) {
        throw new Error(`Invalid environment: ${env}`);
    }
    localStorage.setItem(ENV_OVERRIDE_KEY, env);
    window.location.reload();
}

function currentDatabaseName() {
    switch (getCurrentServerEnv()) {
        case ServerEnv.sandbox:
            return "(default)";
        case ServerEnv.staging:
            return "cyo-staging";
        case ServerEnv.sandbox2:
            return "cyo-sandbox2";
        case ServerEnv.prod:
            return "cyo-prod";
        default:
            console.warn("*** unknown server env: " + getCurrentServerEnv());
            return "(default)";
    }
}

function currentGalleryImageCollectionName() {
    return "gallery-images";
}

function currentStickerSetCollectionName() {
    return "sticker-sets";
}

function currentColorCollectionName() {
    return "colors";
}

function currentFeaturedCollectionsCollectionName() {
    return "featured-colls";
}

function currentConfigCollectionName() {
    return "config";
}

function currentProductSKUCollectionName() {
    return "product-skus";
}

function currentRenderSpecCollectionName() {
    return "render-specs";
}

function getJWTTokenURL() {
    switch (getCurrentServerEnv()) {
        case ServerEnv.sandbox:
        case ServerEnv.sandbox2:
        case ServerEnv.staging:
            return "https://poplabscdn.com/api/get-jwt-token-stg//";
        case ServerEnv.prod:
            return "https://poplabscdn.com/api/get-jwt-token-prd/";
        default: console.warn("*** unknown server env: " + getCurrentServerEnv());
    }
}

function removeImageBGURL() {
    switch (getCurrentServerEnv()) {
        case ServerEnv.sandbox:
        case ServerEnv.sandbox2:
        case ServerEnv.staging:
            return "https://poplabscdn.com/api/process-img-stg/";
        case ServerEnv.prod:
            return "https://poplabscdn.com/api/process-img-prd/";
        default: console.warn("*** unknown server env: " + getCurrentServerEnv());
    }
}

function waitImageUploadURL() {
    switch (getCurrentServerEnv()) {
        case ServerEnv.sandbox:
        case ServerEnv.sandbox2:
        case ServerEnv.staging:
            return "https://poplabscdn.com/api/wait-image-upload-stg/";
        case ServerEnv.prod:
            return "https://poplabscdn.com/api/wait-image-upload-prd/";
        default: console.warn("*** unknown server env: " + getCurrentServerEnv());
    }
}

// No - the double URL is not a bug!
function getUploadURLURL() {
    switch (getCurrentServerEnv()) {
        case ServerEnv.sandbox:
        case ServerEnv.sandbox2:
        case ServerEnv.staging:
            return "https://poplabscdn.com/api/get-upload-url-stg/";
        case ServerEnv.prod:
            return "https://poplabscdn.com/api/get-upload-url-prd/";
        default: console.warn("*** unknown server env: " + getCurrentServerEnv());
    }
}


function isDevMode() {
    return import.meta.env.DEV;
}

function shouldDLog() {
    return import.meta.env.VITE_DEBUG_LOG == "1";
}

function setupEnvironmentLabel() {
    const envLabel = document.getElementById("env-label");
    if (!envLabel) {
        console.warn("Environment label element not found");
        return;
    }

    const currentEnv = getCurrentServerEnv();
    if (currentEnv == "prod") {
        envLabel.style.display = "none";
        return;
    }
    
    // Set text content
    envLabel.textContent = `env: ${currentEnv}`;
    
    // Make clickable
    envLabel.classList.add('env-label-clickable');
    envLabel.style.cursor = 'pointer';        
}

export { ServerEnv, getCurrentServerEnv, setServerEnv, currentDatabaseName, currentGalleryImageCollectionName, currentStickerSetCollectionName, currentColorCollectionName, currentFeaturedCollectionsCollectionName, currentConfigCollectionName, currentProductSKUCollectionName, currentRenderSpecCollectionName, getJWTTokenURL, removeImageBGURL, waitImageUploadURL, getUploadURLURL, setupEnvironmentLabel, isDevMode, shouldDLog };
